import React from 'react';
import { DataGrid } from '@material-ui/data-grid';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import 'moment/locale/hu';

const List = ({ projects }) => {
  const { t } = useTranslation();

  const columns = [
    { field: 'survey_name', headerName: t('project.header.name'), minWidth: 190, flex: 1,
      renderCell: params => (
        params?.value?.is_closed ?
          params.value?.survey_name :
          <a href={ params.value?.link } target="_blank" rel="noreferrer">
            { params.value?.survey_name }
          </a>
      )
    },
    { field: 'type', headerName: t('project.header.type'), minWidth: 190 },
    { field: 'group_name', headerName: t('project.header.groupName'), flex: 0.5 },
    { field: 'date_start', headerName: t('project.header.sent'), minWidth: 130 },
    { field: 'status', headerName: t('project.header.status'), minWidth: 130 },
    { field: 'progress', headerName: t('project.header.progress'), minWidth: 130 },
    { field: 'invite_link', align: 'center', headerName: t('project.header.link'),
      renderCell: params => (
        params.value ?
          <a href={ params.value } target="_blank" rel="noreferrer">
            <OpenInNewIcon fontSize='small'/>
          </a> :
          ''
      )
    }
  ];

  const rows = projects.map(project => {
    const {
      survey_id: id,
      survey_name,
      type,
      group_name,
      date_start,
      is_closed,
      progress,
      invite_link
    } = project;

    return {
      id,
      survey_name: { survey_name: survey_name, link: invite_link, is_closed  },
      type: t(`project.type.${type?.toLowerCase()}`),
      group_name,
      date_start: moment(date_start).format('L'),
      status: is_closed ? t('project.status.closed') : t('project.status.open'),
      progress: t(`project.progress.${progress}`),
      invite_link
    };
  });

  return (
    <div>
      <DataGrid
        rows={ rows }
        columns={ columns }
        checkboxSelection={ false }
        disableSelectionOnClick
        headerHeight={ 42 }
        rowHeight={ 42 }
        autoHeight
        hideFooter={ true }
        disableColumnMenu={ true }
      />
    </div>
  );
};

export default List;
